module.exports = __webpack_public_path__ + "img/icon-lesson.aad505a3.png";